// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-box {
  height: 128px;
  width: 144px;
  margin: 0 auto;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.option-box .image-box ion-icon[name*=custom-boyd-reward] {
  font-size: 6rem;
}
.option-box .image-box ion-icon[name*=custom-mail] {
  font-size: 3.5rem;
}

.option-box-primary {
  background-color: #075490;
}
.option-box-primary .image-box {
  height: 74px;
  width: 120px;
  margin-top: -5px;
}

.option-box-secondary {
  background-color: var(--ion-color-secondary);
}
.option-box-secondary .image-box {
  height: 60px;
  width: 120px;
  margin-top: 10px;
}

p {
  color: var(--ion-color-light);
  font-size: 16px;
  line-height: 20px;
  margin: 5px auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup-options/signup-options.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAIY;EACI,eAAA;AAFhB;AAKY;EACI,iBAAA;AAHhB;;AASA;EACI,yBAAA;AANJ;AAOI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;AALR;;AASA;EACI,4CAAA;AANJ;AAOI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;AALR;;AASA;EACI,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AANJ","sourcesContent":[".option-box{\r\n    height: 128px;\r\n    width: 144px;\r\n    margin: 0 auto;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n\r\n    .image-box{\r\n        ion-icon{\r\n\r\n            &[name*=\"custom-boyd-reward\"] {\r\n                font-size: 6rem;\r\n            }\r\n\r\n            &[name*=\"custom-mail\"] {\r\n                font-size: 3.5rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.option-box-primary{\r\n    background-color: #075490;\r\n    .image-box{\r\n        height: 74px;\r\n        width: 120px;\r\n        margin-top: -5px;\r\n    }\r\n}\r\n\r\n.option-box-secondary{\r\n    background-color: var(--ion-color-secondary);\r\n    .image-box{\r\n        height: 60px;\r\n        width: 120px;\r\n        margin-top: 10px;\r\n    }\r\n}\r\n\r\np{\r\n    color: var(--ion-color-light);\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    margin: 5px auto!important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
